var _desc, _polygon, _polygon2, _polygon3, _polygon4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlugins(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "main_menu/plugins") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), /*#__PURE__*/React.createElement("g", {
    id: "main_menu/plugins",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(20.000000, 7.000000)"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    fill: "#D9D9D9",
    points: "15.292 20.6416 0.149 30.1126 0.149 60.4756 25.063 65.2116 39.978 55.7406 39.978 25.3766"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    fill: "#313036",
    points: "20 58.5689 5 55.6109 5 39.2609 20 42.2199"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    fill: "#167EC4",
    points: "17.0547 23.8037 7.7067 29.6507 7.7067 37.5597 23.0857 40.4837 32.2927 34.6367 32.2927 26.7277"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#00ABE3",
    points: "14.8506 11.7797429 14.8506 0.0151 26.8506 2.4141 26.8506 14.1604571 34.8506 15.7476 20.8506 28.6416 6.8506 10.1926"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-20",
    fill: "#C6C6C6",
    style: {
      mixBlendMode: "multiply"
    },
    points: "25.0625 65.2119 39.9775 55.8879 39.9775 25.3769 25.0625 34.7009"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugins);
export default __webpack_public_path__ + "static/media/plugins.9a2d0eac0013f8ee441e6389fe7c6e12.svg";
export { ForwardRef as ReactComponent };